import request from "@/utils/request";

export function getEventCollections(params) {
	return request({ url: "/admin/event-collections", method: "get", params });
}

export function getEventCollection(id) {
	return request({ url: `/admin/event-collections/${id}`, method: "get" });
}

export function createEventCollection(data) {
	return request({ url: "/admin/event-collections", method: "post", data });
}

export function updateEventCollection(id, data) {
	return request({ url: `/admin/event-collections/${id}`, method: "put", data });
}

export function deleteEventCollection(id) {
	return request({ url: `/admin/event-collections/${id}`, method: "delete" });
}

export function addCollectionActivities(id, activity_ids) {
	return request({
		url: `/admin/event-collections/${id}/activities`,
		method: "post",
		data: { activity_ids },
	});
}

export function importCollectionActivities(id, file) {
	const data = new FormData();
	data.append("file", file);
	return request({
		url: `/admin/event-collections/${id}/import`,
		method: "post",
		data,
	});
}

export function removeCollectionActivity(id, activityId) {
	return request({
		url: `/admin/event-collections/${id}/activities/${activityId}`,
		method: "delete",
	});
}

export function removeCollectionExternalActivity(id, activityId) {
	return request({
		url: `/admin/event-collections/${id}/external-activities/${activityId}`,
		method: "delete",
	});
}
